<template>
    <div>
        <UiCardListHeader
            :title="lang('orders::orders.widgets.latest_orders.title')"
            :action-href="route('orders.admin.index')"
            :action-label="lang('orders::orders.actions.manage')"
        />

        <UiCardEmpty v-if="orders && orders.length === 0">
            {{ lang('orders::orders.widgets.latest_orders.no_orders') }}
        </UiCardEmpty>
        <UiCardList
            v-else-if="orders && orders.length > 0"
            as="transition-group"
            name="slide-fade"
            enter-active-class="transition duration-300 ease-out transform"
            enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-20"
            enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
            leave-active-class="transition duration-100 ease-in"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <order-preview v-for="order in orders" :key="order.id" :order="order"></order-preview>
        </UiCardList>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { Ref } from 'vue';
import { usePage } from '@inertiajs/vue3';
import OrderPreview from '@src/CartOrders/Pages/Order/OrderPreview.vue';

const { props } = usePage();

const components: Ref<any[]> = ref(props.components);

const component = [...components.value].find((component) => component.component === 'OrdersBlock');

const orders = ref(component ? component.orders : []);

const load = () => {
    axios.get(route('orders.admin.api.latest')).then(({ data }) => {
        orders.value = data.orders;
    });
};

window.Echo.channel('admin').listen('.order.created', () => {
    load();
});

if (orders.value.length === 0) {
    load();
}
</script>
